export enum DeviceType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}
